<div class="w-full flex flex-column gap-3">
  <div class="flex gap-3 align-items-center sticky top-0 bg-white py-2">
    <b class="w-auto font-medium text-lg flex-shrink-0">Submissions </b>
    <div *ngFor="let submission of submissions; let i = index" class="inline-flex flex-wrap gap-2">
      <p-button label="{{i+1}}" [styleClass]="'numbering ' + (submission === selectedSubmission ? 'active' : '')"
        (onClick)="openSubmission(submission)"></p-button>
    </div>
    <p-button label="Download" icon="pi pi-download" class="p-0 align-items-right" styleClass="downloadbtn" (onClick)="downloadEssay()"/>
  </div>
  <div class="flex flex-column md:flex-row w-full gap-5 md:gap-0">
    <div class="md:col-7  col-12 p-0 md:pr-3">
    <div class="flex flex-column gap-2 border-1 border-round-lg p-3 border-bluegray-200"
    style="background-color: #F9FBFD;">
    <b class="font-bold text-left" style="color: #000; font-size: 18px;">
      {{ selectedSubmission?.question }}
    </b>
    <small class="inline-block text-left font-normal tex-sm"
      style="color: #898989;">{{selectedSubmission?.createdOn | date:'medium'}}</small>
    <div class="w-full">
      <div class="w-full flex align-items-start" >
        <div class="align-items-start inline-flex flex-column gap-2 border-round-lg bg-white p-3">
          <div #targetText id="targetText" [innerHTML]="sanitizeHtml(selectedSubmission?.htmlAnswer)"></div>
        </div>
      </div>
    </div>
    </div>
    </div>
    <div class="md:col-5 col-12  p-0 md:pl-3 flex flex-column">
      <b class="w-full p-3" style="border-radius: 8px 8px 0 0; font-size: 20px; background-color: #EDF2F9; border: 1px solid #B1C2D9;">Suggestions</b>
      <div class="w-full p-3 flex  flex-column gap-3" style="border-radius: 0 0 8px 8px; background-color: #F6F9FE; border: 1px solid #B1C2D9; border-top: none;">
        <div class="w-full flex flex-column gap-2">
          @for(comment of commentList; track comment){
            <div class="w-full flex flex-column gap-2 p-3 bg-white" style="border: 1px solid #CCD7E7; border-radius: 4px;cursor: pointer;" (click)="highlightComment(comment.id)" >
                <div class="w-full flex align-items-center gap-2 justify-content-between">
                  <b class="w-full text-left font-medium" style="color: #000;">{{comment.selectedText}}</b>
                  <!-- <p-button  icon="pi pi-trash" class="flex-shrink-0" styleClass="deleteReviewBtn"/> -->
                </div>
                <p  style="font-size: 14px; color: #3F414A;">{{comment.comment}}</p>
                <p class="pt-2 mt-2" style="border-top: 1px solid #CCD7E7; font-size: 13px; color: #898989;">{{comment.createdOn | date: 'MMM dd, yyyy'}}</p>
            </div>
          }
        </div>
      </div>
      
  </div>
  </div>
</div>